/* eslint-disable import/no-webpack-loader-syntax */
require('script-loader!jquery/dist/jquery.min.js')
require('script-loader!popper.js/dist/umd/popper.min.js')
require('script-loader!bootstrap/dist/js/bootstrap.min.js')
require('script-loader!./vendor/jquery-rebox.js')
require('script-loader!./vendor/jquery-scroll.js')
require('script-loader!./vendor/mtiFontTrackingCode.js')
